<div class="parent" *ngIf="data?.length">
  <div class="grid">
    <span class="columnHeader"></span>
  </div>
  <div class="grid gridRow" *ngFor="let b of data">
    <span class="pertinent">{{ b.battle?.name }}<i *ngIf="editable" (click)="removeItem(b.battle)" class="fas fa-trash ms-1" title="Remove entry" style="cursor: pointer; float: right; margin: 0.25em;"></i></span>
  </div>

</div>
